<template>
    <div class="select">
        <!-- 选择机构 -->
        <span>选择机构：</span>
        <el-select
            v-model="form.schoolId"
            placeholder="请选择"
            class="organ"
            size="mini"
        >
            <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
            >
            </el-option>
        </el-select>
        <!-- 快速选择时间 -->
        <span>快速选择时间：</span>
        <el-select
            v-model="form.timeRange"
            placeholder="请选择"
            class="time"
            size="mini"
        >
            <el-option
                v-for="item in times"
                :key="item.value"
                :label="item.value"
                :value="item.timeRange"
            >
            </el-option>
        </el-select>
        <!-- 选择时间段 -->
        <span>选择时间段：</span>
        <el-time-picker v-model="form.startTime" placeholder="任意时间点">
        </el-time-picker>
        <el-time-picker v-model="form.endTime" placeholder="任意时间点">
        </el-time-picker>
        <button @click="selectFn">开始统计</button>
    </div>
</template>

<script>
export default {
    props: ["schoolList"],
    data() {
        return {
            // 时间
            times: [
                {
                    value: "-全部-",
                    timeRange: "",
                },
                {
                    value: "今天",
                    timeRange: "0",
                },
                {
                    value: "近七天",
                    timeRange: "1",
                },
                {
                    value: "一个月",
                    timeRange: "2",
                },
                {
                    value: "三个月",
                    timeRange: "3",
                },
                {
                    value: "半年",
                    timeRange: "4",
                },
                {
                    value: "一年",
                    timeRange: "5",
                },
            ],
            form: {
                schoolId: "",
                timeRange: "",
                startTime: "",
                endTime: "",
            },
        };
    },
    methods: {
      selectFn() {
        this.$emit('handleStatistics',this.form)
      },
    },
};
</script>

<style lang="scss" scoped>
.select {
    font-size: 16px;
    height: 30px;
    margin-bottom: 28px;
}
.organ {
    width: 206px;
    height: 30px;
    border: 1px solid #409eff;
    border-radius: 5px;
    margin-right: 32px;
}
.time {
    width: 129px;
    height: 30px;
    border: 1px solid #409eff;
    border-radius: 5px;
    margin-right: 62px;
}
input {
    width: 131px;
    height: 30px;
    border: 1px solid #409eff;
    border-radius: 5px;
}
button {
    width: 131px;
    height: 30px;
    background-color: #409eff;
    border: 1px solid #409eff;
    border-radius: 5px;
    font-size: 18px;
    color: #fff;
    margin-left: 25px;
}
</style>